import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import FaceIdLogin from "../Login/FaceIdLogin";
import axios from "../../axios";
import LoginMpinPassWord from "../Login/LoginMpinPassWord";

export default function SetMpin({ studentAuthDetails, setRegister,
  setIsInProgress }) {
  const navigate = useNavigate();
  const [mpin, setMpin] = useState(null);
  const [confirmMpin, setConfirmMpin] = useState("");
  const [showMpin, setShowMpin] = useState(false);
  const [showConfirmMpin, setShowConfirmMpin] = useState(false);
  const [mpinError, setMpinError] = useState("");
  const [inputFieldsComplete, setInputFieldsComplete] = useState(false);
  const [mpinsMatch, setMpinsMatch] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const schoolCode = localStorage.getItem("schoolCode");


  const [createMpin, setCreateMpin] = useState({
    gotoLoginpage: false,
  });

  const handleMpinChange = (event) => {
    let { value } = event.target;

    if (value.length > 6) {
      value = value.slice(0, 6);
    }
    // Only allow numbers in the MPIN input and restrict to 6 characters
    if (/^\d*$/.test(value) && value.length <= 6) {
      setMpin(value);
    }
    // Check if the MPIN input is complete
    if (value.length === 6 && confirmMpin) {
      setInputFieldsComplete(true); // Set inputFieldsComplete state to true
    } else {
      setInputFieldsComplete(false); // Set inputFieldsComplete state to false
    }
  };

  const handleConfirmMpinChange = (event) => {
    let { value } = event.target;

    if (value.length > 6) {
      value = value.slice(0, 6);
    }
    // Only allow numbers in the confirm MPIN input and restrict to 4 characters
    if (/^\d*$/.test(value) && value.length <= 6) {
      setConfirmMpin(value);
    }
    // Check if the confirm MPIN input is complete
    if (value.length === 6 && mpin) {
      setInputFieldsComplete(true); // Set inputFieldsComplete state to true
    } else {
      setInputFieldsComplete(false); // Set inputFieldsComplete state to false
    }

    // Check if the confirm MPIN matches the MPIN
    if (value !== mpin) {
      setMpinError("MPINs do not match");
      setMpinsMatch(false);
    } else {
      setMpinError();
      setMpinsMatch(true);
      studentAuthDetails.mpin = mpin;
    }
  };
  const toggleShowMpin = () => {
    setShowMpin(!showMpin);
  };
  console.log(mpinError, !inputFieldsComplete, !mpinsMatch)
  const toggleShowConfirmMpin = () => {
    setShowConfirmMpin(!showConfirmMpin);
  };

  const handleStudentRestration = async () => {
    try {
      let res = await axios.post(`/studentAuth/register`, {
        unique_id: studentAuthDetails?.addmissionNumber,
        password: studentAuthDetails?.password,
        mpin: studentAuthDetails?.mpin,
        school_code: schoolCode,

      });
      localStorage.setItem("unique_id", studentAuthDetails?.addmissionNumber)
      // res && setCreateMpin({ createMpin, gotoLoginpage: true });
      res && navigate("/regSuccess");
    } catch (error) {
      setErrorMessage(error?.response?.data?.message + '!!!' || "Your account is not active. Pls contact School!!!!");
      console.log(error);
    }
  };

  return (
    <>
      {!createMpin.gotoLoginpage && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <div className="InsideDetailCpntainer">
                <div className="d-flex justify-content-center">
                  <img
                    className="registrationIcon"
                    src="/StudentImg/BreathSchoolLogo.png"
                    alt="icon"
                  />
                </div>
                <div className="d-flex justify-content-center headerEnterOtp mt-3">
                  Set 6 Digit PIN
                </div>
                <div className=" d-flex justify-content-center MpinTest mt-2">
                  My PIN is your personal number that keeps your account safe
                  from others.<br></br>
                  Let’s keep your data a secret!
                </div>

                <div className=" d-flex justify-content-center ">
                  <div>
                    <div className="d-flex justify-content-between p-3 align-items-center registrationMPinInput  mt-4">
                      <input
                        type={showMpin ? "text" : "password"}
                        id="mpin"
                        className="otpInput"
                        name="mpin"
                        placeholder="New Pin"
                        value={mpin}
                        onChange={handleMpinChange}
                        required
                        maxLength={6}
                      />
                      <span onClick={toggleShowMpin}>
                        {showMpin ? <FiEye /> : <FiEyeOff />}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between p-3 align-items-center registrationMPinInput  mt-4">
                      <input
                        type={showConfirmMpin ? "text" : "password"}
                        id="confirm-mpin"
                        placeholder="Confirm Pin"
                        className="otpInput"
                        name="confirm-mpin"
                        value={confirmMpin}
                        onChange={handleConfirmMpinChange}
                        required
                        maxLength={6}
                      />
                      <span onClick={toggleShowConfirmMpin}>
                        {showConfirmMpin ? <FiEye /> : <FiEyeOff />}
                      </span>
                    </div>
                  </div>
                </div>
                {mpinError && (
                  <div className="mpin_error d-flex justify-content-start">
                    {mpinError}
                  </div>
                )}

                <div className="d-flex flex-column justify-content-center align-items-center mt-4">
                  {errorMessage && (
                    <span className="align-self-center" style={{ color: "red" }}>{errorMessage}</span>
                  )}
                  <button
                    type="submit"
                    onClick={handleStudentRestration}
                    disabled={mpinError || !inputFieldsComplete || !mpinsMatch}
                    className="RegisterBtnMpin"
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {createMpin.gotoLoginpage && (
        <LoginMpinPassWord studentDetails={studentAuthDetails} setRegister={setRegister}
          setIsInProgress={setIsInProgress} />
      )}
      {/* <FaceIdLogin studentAuthDetails={studentAuthDetails} /> */}
    </>
  );
}
